interface DotGridProps {
  height?: number;
  width?: number;
  brand?: 'dti' | 'revpro' | 'victorylive' | 'tktedge' | 'bn';
}

const brandColor = {
  dti: 'var(--colors-dtipurple-4)',
  revpro: 'var(--colors-revpropurple-4)',
  victorylive: 'var(--colors-victorylivepurple-4)',
  tktedge: 'var(--colors-tktedgeblue-4)',
  bn: 'var(--colors-brandcolor-5)',
} as const;

export default function DotGrid({ height = 362, width = 2541, brand = 'bn' }: DotGridProps) {
  return (
    <div className="dot-grid" aria-hidden="true">
      <svg viewBox="0 0 2541 362" height={height} width={width}>
        <g id="dot-layer">
          {brandColor[brand]}
          <circle fill={brandColor[brand]} cx="433" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="433" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="1" r="1" />
          <circle fill={brandColor[brand]} cx="451" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="37" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="19" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="469" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="487" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="37" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="505" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="523" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="541" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="559" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="289" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="307" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="325" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="343" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="361" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="379" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="415" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="397" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="145" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="181" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="181" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="181" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="145" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="145" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="163" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="163" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="145" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="145" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="163" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="163" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="181" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="181" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="181" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="181" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="145" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="145" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="163" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="163" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="145" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="145" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="163" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="163" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="181" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="181" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="181" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="181" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="199" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="217" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="235" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="253" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="271" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="55" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="73" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="127" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="19" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="19" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="55" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="55" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="37" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="37" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="55" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="55" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="19" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="19" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="19" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="19" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="37" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="37" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="55" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="55" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="37" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="37" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="55" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="55" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="73" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="73" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="91" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="91" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="73" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="73" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="91" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="91" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="109" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="109" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="127" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="127" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="109" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="109" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="127" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="127" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="73" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="73" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="91" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="91" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="73" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="73" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="91" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="91" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="109" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="109" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="127" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="127" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="109" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="109" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="127" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="127" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1046" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1046" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1064" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1064" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1046" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1046" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1064" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1064" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1046" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1046" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1064" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1064" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1046" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1046" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1064" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1064" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1010" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1010" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1028" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1046" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1046" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1064" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1064" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1046" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1046" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1064" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1064" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1010" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1010" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1028" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1028" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1010" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1010" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1028" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1028" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1046" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1046" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1064" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1064" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1046" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1046" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1064" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1064" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1082" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1082" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1100" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1100" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1082" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1082" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1100" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1100" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1118" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1118" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1136" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1136" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1100" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1118" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1136" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="37" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1010" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1028" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1082" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="866" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="866" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="884" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="884" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="866" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="866" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="884" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="884" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="902" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="902" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="920" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="920" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="902" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="902" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="920" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="920" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="866" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="866" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="884" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="884" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="866" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="866" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="884" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="884" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="902" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="902" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="920" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="920" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="902" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="902" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="920" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="920" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="956" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="956" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="956" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="956" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="974" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="974" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="974" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="974" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="956" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="956" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="956" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="956" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="974" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="974" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="974" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="974" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="866" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="866" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="884" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="884" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="866" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="866" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="884" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="884" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="902" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="902" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="920" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="920" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="902" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="902" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="920" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="920" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="866" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="866" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="884" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="884" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="866" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="866" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="884" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="884" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="902" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="902" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="920" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="920" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="902" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="902" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="920" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="920" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="938" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="938" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="956" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="956" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="938" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="938" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="956" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="956" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="974" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="974" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="992" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="992" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="974" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="974" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="992" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="992" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="938" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="938" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="956" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="956" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="938" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="938" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="956" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="956" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="974" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="974" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="974" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="974" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="992" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="992" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="902" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="920" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="920" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="37" r="1" />
          <circle fill="#737373" opacity="0.35" cx="956" cy="37" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="956" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="956" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="974" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="974" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="992" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="848" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="848" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="848" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="848" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="794" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="812" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="812" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="830" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="848" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="848" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="830" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="830" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="848" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="848" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="722" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="740" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="758" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="776" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="848" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="848" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="848" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="848" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="794" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="812" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="848" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="848" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="830" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="848" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="848" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="848" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="596" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="614" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="650" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="668" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="686" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="704" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="37" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="578" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="632" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1586" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1586" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1604" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1604" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1586" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1586" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1604" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1604" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1622" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1622" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1640" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1640" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1622" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1622" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1640" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1640" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1586" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1586" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1604" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1604" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1586" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1586" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1604" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1604" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1622" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1622" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1640" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1640" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1622" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1622" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1640" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1640" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1658" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1658" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1658" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1658" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1694" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1694" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1712" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1712" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1694" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1694" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1712" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1712" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1658" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1658" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1658" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1658" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1694" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1694" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1712" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1712" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1694" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1694" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1712" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1712" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1586" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1586" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1604" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1604" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1586" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1586" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1604" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1604" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1622" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1622" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1640" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1640" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1622" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1622" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1640" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1640" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1586" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1586" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1604" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1604" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1586" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1586" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1604" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1604" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1622" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1622" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1640" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1640" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1622" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1622" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1640" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1640" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1658" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1658" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1676" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1676" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1658" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1658" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1676" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1676" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1694" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1694" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1712" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1712" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1694" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1694" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1712" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1712" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1658" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1658" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1676" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1676" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1658" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1658" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1676" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1676" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1694" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1694" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1712" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1712" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1694" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1694" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1712" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1712" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1586" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1640" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="37" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="19" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1658" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1658" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1694" cy="37" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1694" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1694" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1712" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1712" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1676" cy="1" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1478" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1496" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1478" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1478" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1496" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1496" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1478" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1478" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1496" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1496" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1514" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1514" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1532" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1532" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1514" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1514" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1532" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1532" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1550" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1550" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1568" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1568" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1550" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1550" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1568" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1568" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1514" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1532" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1532" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1568" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1550" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1550" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1568" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1568" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1478" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1478" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1496" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1496" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1478" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1478" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1496" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1496" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1442" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1460" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1442" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1442" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1460" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1460" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1478" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1478" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1496" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1496" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1478" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1478" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1496" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1496" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1514" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1514" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1532" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1532" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1514" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1514" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1532" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1532" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1550" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1550" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1568" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1568" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1550" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1550" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1568" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1568" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1514" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1514" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1532" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1532" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1514" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1514" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1532" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1532" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1550" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1550" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1568" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1568" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1550" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1550" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1568" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1568" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1298" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1298" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1298" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1316" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1334" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1352" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1370" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1388" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1388" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1370" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1370" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1388" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1388" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1406" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1406" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1406" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1406" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1298" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1298" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1316" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1316" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1298" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1298" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1316" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1316" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1334" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1334" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1352" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1352" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1334" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1334" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1352" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1352" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1298" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1298" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1316" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1316" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1298" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1298" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1316" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1316" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1334" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1334" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1352" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1352" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1334" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1334" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1352" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1352" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1370" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1370" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1388" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1388" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1370" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1370" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1388" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1388" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1406" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1406" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1406" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1406" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1424" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1370" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1370" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1388" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1388" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1370" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1370" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1388" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1388" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1406" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1406" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1406" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1406" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1424" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="163" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1154" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1154" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1172" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1172" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1190" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1190" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1208" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="325" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="307" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="361" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="343" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1226" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1244" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="253" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="235" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1262" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="289" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1280" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2162" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2180" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2216" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2234" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2252" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2270" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2288" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2198" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="1" r="1" />
          <circle fill={brandColor[brand]} cx="2018" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="2036" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="37" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="19" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="37" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="2054" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="2072" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="2090" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="2108" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="37" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="2126" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="2144" cy="55" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1874" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1874" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1892" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1910" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1928" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1946" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1982" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2000" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1964" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1730" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1730" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1748" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1748" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1730" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1730" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1748" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1748" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1766" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1766" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1784" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1784" cy="91" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1766" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1766" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1784" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1784" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1730" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1730" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1748" cy="181" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1748" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1730" cy="217" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1730" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1748" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1748" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="199" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1802" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1802" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1820" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1802" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="127" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1838" cy="109" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1838" cy="91" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="145" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1856" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="1730" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1730" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1748" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1748" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1730" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1730" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1748" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1748" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1730" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1730" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1748" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1748" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1730" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1730" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1748" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1748" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1766" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1784" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1802" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1820" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1838" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="1856" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1730" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1748" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1748" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1766" cy="37" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1766" cy="73" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1766" cy="55" r="1" />
          <circle fill="#737373" opacity="0.35" cx="1820" cy="73" r="1" />
          <circle fill={brandColor[brand]} cx="2450" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2468" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2522" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2540" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2450" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2450" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2468" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2468" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2450" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2450" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2468" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2468" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2486" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2486" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2504" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2504" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2486" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2486" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2504" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2504" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2450" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2450" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2468" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2468" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2450" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2450" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2468" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2468" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2486" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2486" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2504" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2504" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2486" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2486" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2504" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2504" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2522" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2522" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2540" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2540" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2522" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2522" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2540" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2540" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2522" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2522" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2540" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2540" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2522" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2522" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2540" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2540" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="109" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="127" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="145" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="163" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2414" cy="181" r="1" />
          <circle fill={brandColor[brand]} cx="2414" cy="217" r="1" />
          <circle fill={brandColor[brand]} cx="2414" cy="199" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2306" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2324" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2342" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2360" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2414" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2414" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2432" cy="325" r="1" />
          <circle fill={brandColor[brand]} cx="2432" cy="307" r="1" />
          <circle fill={brandColor[brand]} cx="2414" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2414" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2432" cy="361" r="1" />
          <circle fill={brandColor[brand]} cx="2432" cy="343" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2378" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2396" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2414" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2414" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2432" cy="253" r="1" />
          <circle fill={brandColor[brand]} cx="2432" cy="235" r="1" />
          <circle fill={brandColor[brand]} cx="2414" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2414" cy="271" r="1" />
          <circle fill={brandColor[brand]} cx="2432" cy="289" r="1" />
          <circle fill={brandColor[brand]} cx="2432" cy="271" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="1" r="1" />
          <circle fill="#737373" opacity="0.35" cx="938" cy="19" r="1" />
        </g>
      </svg>
    </div>
  );
}
